import { NormalizedDistributionProduct } from '../../../../../store/managementAnalysis/types';

const productsThatIncludesPaidCustody = ['RENDA_VARIAVEL'];

export const validateIfProductIncludesPaidCustody = (product: NormalizedDistributionProduct) => {
  return productsThatIncludesPaidCustody.includes(product.productClassName);
};

export const paidCustodyTexts = {
  title: 'O que é custódia remunerada?',
  explanation:
    'Custódia remunerada é um produto que permite ao cliente ganhar com a sua posição acionária ou cotas de fundos imobiliários, ao autorizar a mesa de aluguel de ações a fechar negócios caso surja uma posição tomadora no mercado. É uma forma de rentabilizar a carteira de forma passiva, com a corretora se responsabilizando pela devolução dos ativos em caso de venda.',
  observation: 'Observações Importantes:',
  observations: [
    '- Venda dos Ativos: O cliente pode vender suas ações mesmo que estejam doadas. A corretora garante a devolução dos ativos, não havendo risco financeiro adicional para o cliente.',
    '- Descasamento de Fluxos: Pode haver casos de descasamento entre o fluxo de liquidação de venda da B3 (D+2) e o prazo de devolução do doador (D+3). A corretora cobre os custos envolvidos em situações como essa.',
  ],
  link: {
    text: 'Clique aqui para acessar mais informações e orientar seus clientes.',
    url: 'https://lp.genialinvestimentos.com.br/alugueldeacoes/',
  },
};
